import useRenderedEffect from "./use-rendered-effect.js";
export default function useMounted(cb) {
    useRenderedEffect(cb, []);
}
